import React from 'react';

const checkInOutKeywords = [
  "check-in time",
  "check-out time",
  "when is check-in",
  "when is check-out",
  "what time is check-in",
  "what time is check-out",
  "checkin time",
  "checkout time",
  "time to check in",
  "time to check out"
];

const earlyLateCheckKeywords = [
  "early check-in",
  "late check-out",
  "check in early",
  "check out late",
  "early check in",
  "late check out",
  "can i check in early",
  "can i check out late"
];

const transportKeywords = [
  "how do i get to the hostel",
  "how to reach hostel",
  "from airport to hostel",
  "from train station to hostel",
  "how to reach from airport",
  "how to reach from train station",
  "way to hostel",
  "directions to hostel",
  "transport to hostel",
  "reach hostel from airport",
  "reach hostel from train"
];

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    const messageLower = message.toLowerCase();
    if (message.includes('hello')) {
      actions.handleHello()
    } else if (message.includes('bye')){
      actions.handleBye()
    } else if (["reservation", "book", "booking", "make a reservation"].some(word => messageLower.includes(word))) {
      actions.handleReservation();
    } else if (["pay in advance", "payment in advance", "advance payment", "need to pay before", "do i need to pay now", "pay before",
    "upfront payment"].some(word => messageLower.includes(word))) {
      actions.handlePayAdvance();
    } else if (checkInOutKeywords.some(keyword => messageLower.includes(keyword))) {
      actions.handleCheckInOutTime();
    } else if (earlyLateCheckKeywords.some(keyword => messageLower.includes(keyword))) {
      actions.handleEarlyLateCheck();
    } else if (transportKeywords.some(keyword => messageLower.includes(keyword))) {
      actions.handleTransportInfo();
    }
    
    else {
      actions.handleUnknown();
    }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;